import React, { Component } from 'react'
import { Switch, Route, withRouter } from 'react-router'
import { connect } from 'react-redux'
import Project from './project/project'
import ProjectsIndex from './projects-index'
import { getCurrentAccount } from 'state/selectors/accountSelector'

class Projects extends Component {
  shouldComponentUpdate = nextProps => {
    if(this.props.sidebarHidden !== nextProps.sidebarHidden){
      return false
    }

    return true
  }
  
	render() {
    const {
      match,
      folderChain,
      currentAccount
    } = this.props

		return (
       <Switch key={match.url}>
          <Route 
            path={match.url+"/:project_slug"} 
            currentAccount={currentAccount} 
            render={routeProps => (
              <Project 
                {...routeProps} 
                currentAccount={currentAccount} 
              />
            )} 
          />
          <Route 
            path={match.url+"/"} 
            currentAccount={currentAccount} 
            render={routeProps => (
              <ProjectsIndex 
                {...routeProps} 
                folderChain={folderChain} 
                currentAccount={currentAccount} 
              />
            )}
          />
       </Switch>
		);
	}
}

const mapStateToProps = state => {
  return {
		folderChain: state.account.folderChain,
    currentAccount: getCurrentAccount(state),
  };
}

export default withRouter(connect(mapStateToProps)(Projects));



// WEBPACK FOOTER //
// ./src/sections/projects/projects.jsx